import Documents from "./DocumentsContainer";

export default Documents;
